export default __webpack_public_path__ + "static/media/setting.b4aacc93.svg";